import { apiFetch } from "../http";
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    if (typeof data.errors === "string")
        return data.errors;
    if (data.errors && typeof data.errors === "object") {
        return Object.values(data.errors).join(", ");
    }
    return data.detail || data.message || fallback;
};
export async function getUserProfile(params) {
    const { baseUrl, token, userId, signal } = params;
    const data = await apiFetch(`/user/api/user/profile/${userId}/`, {
        baseUrl,
        token,
        method: "GET",
        signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.errors) || !(data === null || data === void 0 ? void 0 : data.user_profile)) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить профиль пользователя"));
    }
    return data;
}
export async function getUserActiveTravels(params) {
    const { baseUrl, token, userId, signal } = params;
    const data = await apiFetch(`/user/api/user/profile/${userId}/active_travels/?view=compact`, {
        baseUrl,
        token,
        method: "GET",
        signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false
        || (!Array.isArray(data === null || data === void 0 ? void 0 : data.travels) && !Array.isArray(data === null || data === void 0 ? void 0 : data.active_travels))) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить путешествия пользователя"));
    }
    return data;
}
export async function addFriend(params) {
    const { baseUrl, token, userId, friendUsername } = params;
    return apiFetch(`/user/api/user/add_friend/${userId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ friendUsername })
    });
}
export async function searchUsers(params) {
    const { baseUrl, token, query, signal } = params;
    return apiFetch(`/user/api/friends/users_search/?query=${encodeURIComponent(query)}`, {
        baseUrl,
        token,
        method: "GET",
        headers: { Accept: "application/json" },
        signal
    });
}
export async function uploadUserAvatar(params) {
    const { baseUrl, token, csrfToken, file } = params;
    const formData = new FormData();
    formData.append("img_user", file);
    return apiFetch(`/user/api/add_user_image_lk/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
}
export async function getUserTaskStatus(params) {
    const { baseUrl, token, taskId } = params;
    return apiFetch(`/user/api/task_status/${taskId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function checkUsernameAvailability(params) {
    const { baseUrl, token, username } = params;
    return apiFetch(`/user/api/user/check-username/?username=${encodeURIComponent(username.trim())}`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function updateUserProfile(params) {
    const { baseUrl, token, payload } = params;
    return apiFetch(`/user/api/user/update_user_profile/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
}
export async function getUserSettings(params) {
    const { baseUrl, token, signal } = params;
    const data = await apiFetch(`/user/api/user/settings/`, {
        baseUrl,
        token,
        method: "GET",
        signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false || !(data === null || data === void 0 ? void 0 : data.settings)) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить настройки пользователя"));
    }
    return data;
}
export async function getUserPaymentHistory(params) {
    const { baseUrl, token, page = 1, pageSize = 20, signal } = params;
    const search = new URLSearchParams({
        page: String(Math.max(1, Math.trunc(page))),
        page_size: String(Math.max(1, Math.min(100, Math.trunc(pageSize)))),
    });
    const data = await apiFetch(`/user/api/user/settings/payment_history/?${search.toString()}`, {
        baseUrl,
        token,
        method: "GET",
        signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false || !Array.isArray(data === null || data === void 0 ? void 0 : data.items)) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить историю операций"));
    }
    return data;
}
export async function getUserReferralHistory(params) {
    const { baseUrl, token, page = 1, pageSize = 20, signal } = params;
    const search = new URLSearchParams({
        page: String(Math.max(1, Math.trunc(page))),
        page_size: String(Math.max(1, Math.min(100, Math.trunc(pageSize)))),
    });
    const data = await apiFetch(`/user/api/user/settings/referral_history/?${search.toString()}`, {
        baseUrl,
        token,
        method: "GET",
        signal,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false || !(data === null || data === void 0 ? void 0 : data.summary) || !Array.isArray(data === null || data === void 0 ? void 0 : data.items)) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить историю приглашений"));
    }
    return data;
}
export async function getUnreadNotificationsCount(params) {
    const { baseUrl, token, userId, signal } = params;
    const data = await apiFetch(`/user/api/user/profile/${userId}/unread_notifications_count/`, {
        baseUrl,
        token,
        method: "GET",
        signal,
        redirectOnUnauthorized: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false || !(data === null || data === void 0 ? void 0 : data.data)) {
        throw new Error(getErrorMessage(data, "Не удалось загрузить счетчик уведомлений"));
    }
    return data;
}
export async function updateUserSettings(params) {
    const { baseUrl, token, payload } = params;
    return apiFetch(`/user/api/user/settings/update/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}
export async function requestAccountDeletion(params) {
    const data = await apiFetch(`/user/api/user/settings/delete_account/`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "POST",
        redirectOnUnauthorized: false,
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(data.error || data.detail || data.message || "Не удалось удалить аккаунт");
    }
    return data;
}
export async function changeUserEmail(params) {
    const { baseUrl, token, email } = params;
    return apiFetch(`/user/api/user/settings/change_email/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });
}
export async function changeUserPasswordSettings(params) {
    const { baseUrl, token, currentPassword, password, passwordConfirmation } = params;
    return apiFetch(`/user/api/user/settings/change_password/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            current_password: currentPassword !== null && currentPassword !== void 0 ? currentPassword : "",
            password,
            password_confirmation: passwordConfirmation,
        }),
    });
}
export async function checkEmailAvailability(params) {
    const { baseUrl, token, email } = params;
    return apiFetch(`/user/user/api/user/check-email/?email=${encodeURIComponent(email.trim())}`, {
        baseUrl,
        token,
        method: "GET",
    });
}
export async function cancelFriendRequest(params) {
    const { baseUrl, token, requestId, userId } = params;
    return apiFetch(`/user/api/friends/cancel/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
    });
}
export async function removeFriendRequest(params) {
    const { baseUrl, token, requestId, userId } = params;
    return apiFetch(`/user/api/friends/remove/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
    });
}
export async function acceptFriendRequest(params) {
    const { baseUrl, token, requestId, userId } = params;
    return apiFetch(`/user/api/friends/accept/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" }
    });
}
export async function deleteFriend(params) {
    const { baseUrl, token, userProfileId, friendId } = params;
    return apiFetch(`/user/api/friends/delete_friend/${userProfileId}/${friendId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
    });
}
export async function removeTravelRequest(params) {
    const { baseUrl, token, csrfToken, requestId, userId } = params;
    return apiFetch(`/user/api/travel/remove/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
    });
}
export async function acceptTravelRequest(params) {
    const { baseUrl, token, csrfToken, requestId, userId } = params;
    return apiFetch(`/user/api/travel/accept/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
    });
}
export async function removeAcceptedTravelRequest(params) {
    const { baseUrl, token, csrfToken, requestId, userId } = params;
    return apiFetch(`/user/api/travel/remove_accept/${requestId}/${userId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
    });
}
export async function deleteUserNotification(params) {
    const { baseUrl, token, notificationType, notificationId, userId } = params;
    return apiFetch(`/user/api/notifications/delete/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            user_id: userId,
            notification_type: notificationType,
            notification_id: notificationId,
        }),
    });
}
export async function deleteAllUserNotifications(params) {
    const { baseUrl, token, userId } = params;
    return apiFetch(`/user/api/notifications/delete-all/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
    });
}
export async function markNotificationRead(params) {
    const { baseUrl, token, userId, notificationType, notificationId } = params;
    return apiFetch(`/user/api/notifications/read/`, {
        baseUrl,
        token,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            user_id: userId,
            notification_type: notificationType,
            notification_id: notificationId,
        }),
    });
}
export async function getUserReferralLink(params) {
    const { baseUrl, token, csrfToken, forceNew = false, source } = params;
    const normalizedSource = typeof source === "string" ? source.trim() : "";
    // GET: получить существующую активную ссылку/создать при отсутствии.
    // POST: использовать, когда нужно передать source или force_new.
    if (!forceNew && !normalizedSource) {
        return apiFetch(`/user/api/user/referral/link/`, {
            baseUrl,
            token,
            method: "GET",
        });
    }
    return apiFetch(`/user/api/user/referral/link/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: JSON.stringify({
            force_new: Boolean(forceNew),
            ...(normalizedSource ? { source: normalizedSource } : {}),
        }),
    });
}
